import { Component, computed, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthStoreService } from '../core/auth-store.service';

type NavLink = {
  label: string;
  path: string;
  icon?: string;
  exact?: boolean;
};

@Component({
  selector: 'app-nav',
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './nav.html',
  styleUrls: ['./nav.scss'],
})
export class NavComponent {
  private readonly authStore = inject(AuthStoreService);
  private readonly router = inject(Router);

  readonly sidebarMode = input(false);
  open = signal(false);
  currentUser = this.authStore.currentUser;
  canAccessOrganizationApp = this.authStore.canAccessOrganizationApp;
  canManageQuestionnaires = this.authStore.canManageQuestionnaires;
  canManageUsers = this.authStore.canManageUsers;
  canManageMatrices = this.authStore.canManageMatrices;
  canManageBusinesses = this.authStore.canManageBusinesses;
  canManageInvitations = this.authStore.canManageInvitations;
  isAuthenticated = this.authStore.isAuthenticated;
  publicLinks: NavLink[] = [{ label: 'Inicio', path: '/', exact: true }];
  links = computed<NavLink[]>(() => {
    const items: NavLink[] = [
      { label: 'Dashboard', path: '/dashboard/kyc', icon: '◫', exact: true },
      {
        label: 'KYC completados',
        path: '/dashboard/kyc/completed',
        icon: '✓',
        exact: true,
      },
      {
        label: 'Revisión KYC',
        path: '/dashboard/kyc/review',
        icon: '◉',
        exact: false,
      },
    ];

    if (this.canManageQuestionnaires()) {
      items.push({ label: 'Cuestionarios', path: '/questionnaires', icon: '✦', exact: true });
    }

    if (this.canManageUsers()) {
      items.push({ label: 'Gestión de usuarios', path: '/users', icon: '◌', exact: true });
    }

    if (this.canManageMatrices()) {
      items.push({ label: 'Matrices de riesgo', path: '/matrices', icon: '▦', exact: true });
    }

    if (this.canManageBusinesses()) {
      items.push({ label: 'Empresas', path: '/businesses', icon: '◈', exact: true });
    }

    if (this.canManageInvitations()) {
      items.push({ label: 'Invitaciones KYC', path: '/invitations', icon: '✉', exact: true });
    }

    return items;
  });

  toggle() {
    this.open.update((v) => !v);
  }

  closeMenu() {
    this.open.set(false);
  }

  isCurrentPage(link: NavLink): boolean {
    if (link.exact) {
      return this.router.url === link.path || this.router.url.startsWith(link.path + '?');
    }
    return this.router.url.startsWith(link.path);
  }

  logout() {
    this.authStore.clearSession();
    this.open.set(false);
    this.router.navigate(['/login']);
  }
}
